// store/modules/futures.js
const state = {
  bets: []  // sadece aktif kullanıcıya ait pozisyonlar
}

const getters = {
  futuresBets: state => state.bets,
  futuresActiveBets: state => state.bets.filter(b => b.status === 'open'),
  futuresClosedBets: state => state.bets.filter(b => b.status === 'closed')
}

const mutations = {
  futures_add_or_update_bet(state, bet) {
    const idx = state.bets.findIndex(b => b._id === bet._id)
    if (idx >= 0) {
      state.bets.splice(idx, 1, bet) // update
    } else {
      state.bets.push(bet) // add
    }
  }
}

export default {
  state,
  getters,
  mutations
}
